/* eslint-disable */
import { StyleSheet,Dimensions , Platform} from 'react-native'
import { Colors, Metrics, Fonts } from '../../Themes/'

export default StyleSheet.create({
  container: {
    justifyContent: `flex-end`,

    borderRadius: Platform.OS === 'ios' ? 10 : 0,
  
    width: Dimensions.get('window').width - 80,
    height: 120,
    overflow: "hidden",
  },
  top : {
    marginBottom: 10
  },
  bottom : {
    height: 44,
    borderBottomLeftRadius : 10,
    borderBottomRightRadius : 10,
    flexDirection: `row`
  },
  title : {
    alignSelf: `center`,
    textAlign: `center`

  },
  buttonText : {
    color : Fonts.style.color.baseColor
  },
  textStyle :{
    alignSelf: `center`
  },
  button : {
    width: `50%`,
    height: 44,
   
    borderColor:Fonts.style.color.baseColor,
    borderWidth : 1,
    backgroundColor: `#FFFFFF`,
    justifyContent: `center`,
    alignItems: `center`,
  
  },
  radiusLeft : {
    borderBottomLeftRadius : 10,

  },
  radiusRight : {
    borderBottomRightRadius : 10

  }
})
